var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusSync(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "refresh-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 13.333,
    viewBox: "0 0 13.333 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.11,14.44v2.778",
    transform: "translate(0.618 -5.307)",
    fill: "none",
    stroke: "#74c877",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.111,5.556a5.558,5.558,0,0,1-5.556,5.556C2.489,11.111.617,8.022.617,8.022H3.128M0,5.556A5.543,5.543,0,0,1,5.556,0a6.834,6.834,0,0,1,5.556,3.089m0,0V.311m0,2.778H8.645",
    transform: "translate(1.111 1.111)",
    fill: "none",
    stroke: "#74c877",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H13.333V13.333H0Z",
    transform: "translate(13.333 13.333) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSync);
export default __webpack_public_path__ + "static/media/status-sync.16825a6cfbb432431a302d0bd77728b4.svg";
export { ForwardRef as ReactComponent };